import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/ProSel',
    name: 'ProSel',
    component: () => import('../views/ProSel.vue')
  },
  {
    path: '/SelRes',
    name: 'SelRes',
    component: () => import('../views/SelRes.vue')
  },
  {
    path: '/CostRes',
    name: 'CostRes',
    component: () => import('../views/CostRes.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
